import React, {Component} from 'react'
import {connect} from "react-redux";
import {Control, Form, Errors} from "react-redux-form";
import {Row, Panel, Button} from 'react-bootstrap'
import {toast} from 'react-toastify';
import {Redirect} from "react-router-dom";
import Title from '../../common/page-title'
import ToastMessage from "../../common/toast-message";
import {initialStates} from '../../../initialStates'
import DelinkForm from './delink-form'
import ConfirmationField from './confirmation-row'
import {getAdminOutlet, getCustomerNumbers, delinkOutlet} from "../../../actions/outlet";
import * as moment from 'moment'

import './delink.css'

class DelinkPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step:       1,
      formOutlet: {},
      form:       initialStates.admin_delink
    };
    this.props.dispatch({type: 'CLEAR_OUTLET_DELINK'});

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleFinalize = this.handleFinalize.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.match.params.id !== this.props.match.params.id && !nextProps.match.params.id) ||
      (nextProps.delink.delinked && !this.props.delink.delinked)) {
      this.setState({
        step:       1,
        formOutlet: {},
        form:       initialStates.admin_delink
      });
      this.props.dispatch({type: 'CLEAR_OUTLET_DELINK'});
    }
  }

  componentWillMount() {
    const outletId = this.props.match.params.id;

    const {dispatch} = this.props;

    if (outletId !== undefined) {
      dispatch(getAdminOutlet(outletId));
    }

    dispatch(getCustomerNumbers());
  }

  handleBack(e) {
    this.setState({step: 1, form: initialStates.admin_delink, formOutlet: this.state.formOutlet});
  }

  handleSubmit(payLoad) {
    if (payLoad.outlet === '') {
      toast.error(<ToastMessage iconStyle="error" message="You have to select an outlet first!"/>);
      return false;
    }
    const formOutlet = this.props.outlets.find((e) => e.id == payLoad.outlet);
    this.setState({step: 2, form: payLoad, formOutlet: formOutlet});
    this.forceUpdate();
  }

  handleFinalize(payLoad) {
    this.props.dispatch(delinkOutlet(payLoad));
  }

  notFoundErrorRender() {
    const errors = this.props.errors;
    if (typeof errors === "string" && errors === 'Not Found') {
      toast.error(<ToastMessage iconStyle="error" message={`Outlet not found by id ${this.props.match.params.id}`}/>);

      return true;
    } else {
      return false;
    }
  }

  confirm() {
    const data = this.state.form;
    const outlet = this.state.formOutlet;

    return (
      <Form model='deep.admin_delink' onSubmit={this.handleFinalize}>

        <Errors className="errors" model="deep.admin_delink"/>
        <Panel className="mg-top-20"
               footer={
                 <Row>
                   <div className="col-md-6 text-left">
                     <Button onClick={this.handleBack} className="btn red-ghost-btn">Back</Button>
                   </div>
                   <div className="col-md-6 text-right">
                     <Button type="submit" className="btn red-ghost-btn">Confirm and Process</Button>
                   </div>
                 </Row>
               }>
          <ConfirmationField label="Outlet">{outlet.attributes.name}</ConfirmationField>
          <ConfirmationField
            label="User to be unlinked">{outlet.attributes.owner ? outlet.attributes.owner.name : outlet.attributes.user}</ConfirmationField>
          <ConfirmationField label="Data of delinking">{moment(data.delink_date).format("DD/MM/YYYY")}</ConfirmationField>
          <ConfirmationField label="Description">{data.delink_reason}</ConfirmationField>
          <ConfirmationField
            label="Notification to be sent?">{data.supress_notification ? 'No' : 'Yes'}</ConfirmationField>
          <Control type="hidden" model=".outlet" value={data.outlet} required/>
          <Control type="hidden" model=".delink_date" value={data.delink_date} required/>
          <Control type="hidden" model=".delink_reason" value={data.delink_reason} required/>
          <Control type="hidden" model=".supress_notification" value={data.supress_notification} required/>
        </Panel>
      </Form>
    );
  }

  render() {
    if (this.notFoundErrorRender()) {
      return <Redirect to="/admin/outlets"/>;
    }

    let outlet = this.props.outletFetched ? this.props.outlet : undefined;
    let content;

    switch (this.state.step) {
      default: {
        content = <DelinkForm selectedOutlet={outlet}
                              outlets={this.props.outlets}
                              fetched={this.props.fetched}
                              handleSubmit={this.handleSubmit}/>
        break;
      }
      case 2: {
        content = this.confirm();
        break;
      }
    }

    return (
      <div className="container-fluid">
        <Title>Delink</Title>

        {this.props.outletFetching ? <p>Loading...</p> : content}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    outlets:        state.customer_numbers.outlets,
    fetched:        state.customer_numbers.fetched,
    outlet:         state.store.outlet,
    outletFetched:  state.store.fetched,
    outletFetching: state.store.fetching,
    errors:         state.store.errors,
    delink:         state.delink
  }
};

export default connect(mapStateToProps)(DelinkPage)


// WEBPACK FOOTER //
// ./src/components/admin/delink/index.jsx